const formatChatParticipants = value => {
  let formatted = "";

  if (value) {
    const channel: any = _.find(value, {role: "Channel"});

    if (channel) {
      formatted = channel.id;
    } else {
      value.forEach((v, i) => {
        if (value.length == 1) {
          formatted = v.name || v.id;
        } else if (i < value.length - 1) {
          formatted += (v.name || v.id);
          if (i < value.length - 2) {
            formatted += ", ";
          }
        } else {
          formatted += " &amp; " + (v.name || v.id);
        }
      });
    }
  }

  return formatted || "Unknown";
};
frontendApp.filter('chatParticipants', [() => formatChatParticipants]);
